export enum OCCUPANCY_RATE_MODEL {
    OCCUPANCY = 1,
    ROOM = 2,
    PERSON = 3,
}

export enum PERSON_TYPES {
    ADULT = 10,
    CHILD = 8,
}

export type IOccupancyRateModel =
    (typeof OCCUPANCY_RATE_MODEL)[keyof typeof OCCUPANCY_RATE_MODEL];

export type IOccupancyRatePersonRateType =
    (typeof PERSON_TYPES)[keyof typeof PERSON_TYPES];

export interface IOccupancyRatePersonRate {
    personType: IOccupancyRatePersonRateType;
    personIndex: number;
    ageSegment: number;
    abt: number;
    aat: number;
}

export interface IOccupancyRateOccupancy {
    adults: number;
    children: number;
    abt: number;
    aat: number | null;
}

export interface IStaticRateDateOccupancyRateParsed {
    model: IOccupancyRateModel;
    room: {
        abt: number;
        aat: number;
    };
    persons: {
        singleUseAllowed: boolean;
        rates: IOccupancyRatePersonRate[];
    };
    occupancies: IOccupancyRateOccupancy[];
}
